import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from 'store/useAuthStore'

const PrivateRoute = () => {
    // store
    const { isLogin, userInfo } = useAuthStore()
    const location = useLocation()

    // 인증되지 않은 경우 로그인 페이지로 리다이렉트
    if (!isLogin) {
        return <Navigate to="/login" replace />
    }

    // 강사가 아닌 경우는 마이페이지 접근 불가능
    if (!userInfo?.isTutor && location.pathname === '/tutor-mypage') {
        return <Navigate to="/" replace />
    }

    // 강사는 마이페이지와 비밀번호 변경 페이지만 접근 가능 (마스터는 제외)
    if (userInfo?.isTutor && !userInfo?.isMaster && location.pathname !== '/tutor-mypage' && location.pathname !== '/accounts/password') {
        return <Navigate to="/tutor-mypage" replace />
    }

    // 권한이 있으면 자식 라우트를 렌더링
    return <Outlet />
}

export default PrivateRoute
